import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CourseCard = ({ course }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const formatPrice = (price, isFree) => {
    if (isFree) return 'Free';
    return `${price} NESOL`;
  };

  const enrollmentLabel = {
    open: 'Open Enrollment',
    invite: 'Invite Only',
    cohort: 'Cohort',
    csv: 'Bulk Enrollment',
  }[course?.enrollmentType] || 'Enrollment';

  const previewLink = course?.isLive
    ? `/course-preview?orgId=${course?.orgId}&courseId=${course?.courseId}`
    : '/user-dashboard';

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden card-shadow hover-scale transition-smooth group">
      <div className="relative aspect-video overflow-hidden bg-muted">
        {course?.thumbnail ? (
          <Image
            src={course?.thumbnail}
            alt={course?.title}
            className={`w-full h-full object-cover transition-smooth group-hover:scale-105 ${
              imageLoaded ? 'opacity-100' : 'opacity-0'
            }`}
            onLoad={() => setImageLoaded(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Icon name="BookOpen" size={32} className="text-muted-foreground" />
          </div>
        )}

        <div className="absolute top-3 right-3">
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${
              course?.isFree ? 'bg-success text-success-foreground' : 'bg-card text-foreground'
            }`}
          >
            {formatPrice(course?.price, course?.isFree)}
          </span>
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-medium text-accent uppercase tracking-wide">{course?.category}</span>
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground">
            {enrollmentLabel}
          </span>
        </div>

        <h3 className="font-semibold text-foreground mb-2 line-clamp-2 group-hover:text-accent transition-smooth">
          {course?.title}
        </h3>

        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{course?.description}</p>

        <div className="flex items-center gap-1.5 mb-3">
          <span className="text-xs text-foreground font-medium">{course?.providerName}</span>
          {course?.providerVerified && (
            <span className="flex items-center" title="Verified institution">
              <Icon name="BadgeCheck" size={14} className="text-accent" />
            </span>
          )}
        </div>

        <div className="flex items-center gap-4 text-xs text-muted-foreground mb-4">
          <span className="flex items-center gap-1">
            <Icon name="Layers" size={12} /> {course?.moduleCount} modules
          </span>
          <span className="flex items-center gap-1">
            <Icon name="PlayCircle" size={12} /> {course?.lessonCount} lessons
          </span>
        </div>

        <Link to={previewLink}>
          <Button variant="outline" fullWidth>
            View Course
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CourseCard;